import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import { addPartnerOption } from 'constants/addPartnerOption';

import { useCapitalIncreaseModal } from '../context/CapitalIncreaseModalContext';
import { baseDataForCapitalIncrease } from '../constants/baseDataForCapitalIncrease';

const CapitalIncreaseModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useCapitalIncreaseModal();

  const hasValidDate = data.date && data.date >= data.lastOperationDate;

  const buttonEnabledScriptureView =
    data.scriptureView && hasValidDate && data.totalSharesToAdd > 0;

  const buttonEnabledSaveMovement =
    data.sharesToAdd > 0 &&
    data.remainingShares >= data.sharesToAdd &&
    data.selectedPartner &&
    data.selectedPartner !== addPartnerOption.value &&
    data.selectedHoldingClass &&
    !data.isValidateRangeEnabled &&
    data.availableRange.from !== 0;

  const buttonEnabledMovementsView =
    !data.scriptureView && data.remainingShares === 0 && data.sharesToAdd === 0;

  const buttonText = data.scriptureView ? t('Next') : t('SaveCapitalIncrease');

  const showUploadMockButton =
    process.env.NODE_ENV === 'development' &&
    baseDataForCapitalIncrease.partners.length > 0;

  return (
    <Modal.Footer>
      <div className="d-flex justify-content-between w-100 align-items-center">
        <div className="d-flex">
          {!data.scriptureView && (
            <button
              type="button"
              className="btn btn-lg btn-primary"
              onClick={actions.handleSaveMovement}
              disabled={!buttonEnabledSaveMovement}
            >
              {t('SaveMovement')}
            </button>
          )}
          {showUploadMockButton && (
            <button
              type="button"
              className="btn btn-lg btn-outline-secondary ml-2"
              onClick={actions.handleUploadMock}
            >
              {t('UploadMock')}
            </button>
          )}
        </div>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSaveCapitalIncrease}
          disabled={!buttonEnabledScriptureView && !buttonEnabledMovementsView}
        >
          {buttonText}
        </button>
      </div>
    </Modal.Footer>
  );
};

export default CapitalIncreaseModalFooter;
